import { render, staticRenderFns } from "./PartnerAffiliateLayout.vue?vue&type=template&id=e06e599c&scoped=true&"
import script from "./PartnerAffiliateLayout.vue?vue&type=script&lang=ts&"
export * from "./PartnerAffiliateLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerAffiliateLayout.vue?vue&type=style&index=0&id=e06e599c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e599c",
  null
  
)

export default component.exports